var foo = 'yes';
console.log( foo );